import { useState, useEffect } from 'react'
import { THEME_KEY } from '@/utils/constants'

/**
 * Hook pour gérer le thème sombre/clair
 * Persiste le choix dans localStorage
 */
const useTheme = () => {
  const [theme, setTheme] = useState(() => {
    // Lire le thème depuis localStorage ou utiliser la préférence système
    const stored = localStorage.getItem(THEME_KEY)
    if (stored) return stored
    
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  })

  useEffect(() => {
    const root = window.document.documentElement
    
    // Retirer l'ancien thème
    root.classList.remove('light', 'dark')
    
    // Ajouter le nouveau thème
    root.classList.add(theme)
    
    // Persister dans localStorage
    localStorage.setItem(THEME_KEY, theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light')
  }

  return [theme, toggleTheme]
}

// Export both named and default for compatibility
export { useTheme }
export default useTheme

